import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isoCurrencyToSymbol', standalone: true })
export class IsoCurrencyToSymbolPipe implements PipeTransform {
  private cache = new Map<string, string>();

  private getSymbol(code: string): string {
    const key = code;
    const hit = this.cache.get(key);
    if (hit) return hit;
    try {
      const parts = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code
      }).formatToParts(0);
      const sym = parts.find(p => p.type === 'currency')?.value ?? code;
      const out = sym && sym !== code ? sym : code;
      this.cache.set(key, out);
      return out;
    } catch {
      this.cache.set(key, code);
      return code;
    }
  }

  transform(text: string | null | undefined): string {
    if (!text) return '';
    // Reemplaza cualquier token de 3 letras mayúsculas si es divisa válida
    return text.replace(/\b[A-Z]{3}\b/g, (code) => this.getSymbol(code));
  }
}